import { PolicyValidator, Policy, checkLicense } from '../policy.interface';

const appPolicy: PolicyValidator = {
    validate: (policy: Policy) => {
        return checkLicense(policy, 'user_management');
    }
};

export default appPolicy;
